import { css } from '@backyard-ui/styles';

const styles = css({
  display: 'inline-flex',
  flex: '0 0 auto',
  alignItems: 'center',
  justifyContent: 'center',

  minHeight: '$5',
  paddingY: '$1',
  paddingX: '$2',

  overflow: 'hidden',
  boxSizing: 'border-box',

  fontSize: '$tsm',
  fontWeight: '$bold',

  color: '$n800',

  textAlign: 'center',
  textOverflow: 'ellipsis',
  lineHeight: 1,

  borderRadius: '$xl',
  background: '$n200',

  cursor: 'default',
  userSelect: 'none',
});

export default styles;
